"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _reactDates = require("react-dates");

var _reactMomentProptypes = _interopRequireDefault(require("react-moment-proptypes"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _DatePicker = require("./DatePicker");

var _LinkListItem = _interopRequireDefault(require("../Navigation/LinkListItem"));

require("react-dates/initialize");

require("react-dates/lib/css/_datepicker.css");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

var _LinkList = _interopRequireDefault(require("../Navigation/LinkList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// Theme
const DateReturnType = {
  Moment: 'Moment',
  // Moment obj
  Date: 'Date',
  // Javascript Date
  String: 'String' // ISO String Date

};
const PredefinedPresets = {
  Today: 'today',
  Yesterday: 'yesterday',
  Last7Days: 'last7Days',
  Last30Days: 'last30Days',
  MonthToDate: 'monthToDate',
  PreviousMonth: 'previousMonth'
};

const predefinedPresetsBuilder = function predefinedPresetsBuilder() {
  let dateReturnType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DateReturnType.Date;

  const parse = date => {
    if (dateReturnType !== DateReturnType.Moment) {
      const jsDate = new Date(date);
      return dateReturnType === DateReturnType.String ? jsDate.toISOString() : jsDate;
    }

    return date;
  };

  return {
    [PredefinedPresets.Today]: () => ({
      text: 'Today',
      start: parse((0, _moment.default)()),
      end: parse((0, _moment.default)())
    }),
    [PredefinedPresets.Yesterday]: () => ({
      text: 'Yesterday',
      start: parse((0, _moment.default)().subtract(1, 'days')),
      end: parse((0, _moment.default)().subtract(1, 'days'))
    }),
    [PredefinedPresets.Last7Days]: () => ({
      text: 'Last 7 days',
      start: parse((0, _moment.default)().subtract(7, 'days')),
      end: parse((0, _moment.default)().subtract(1, 'days'))
    }),
    [PredefinedPresets.MonthToDate]: () => ({
      text: 'Month to date',
      start: parse((0, _moment.default)().startOf('month')),
      end: parse((0, _moment.default)())
    }),
    [PredefinedPresets.Last30Days]: () => ({
      text: 'Last 30 days',
      start: parse((0, _moment.default)().subtract(30, 'days')),
      end: parse((0, _moment.default)().subtract(1, 'days'))
    }),
    [PredefinedPresets.PreviousMonth]: () => ({
      text: 'Previous month',
      start: parse((0, _moment.default)().subtract(1, 'month').startOf('month')),
      end: parse((0, _moment.default)().subtract(1, 'month').endOf('month'))
    })
  };
};

const StyledWrapper = _styledComponents.default.div.withConfig({
  displayName: "DateRangePicker__StyledWrapper",
  componentId: "design-system__sc-1vfgtnt-0"
})([".DateRangePicker{height:2.5rem;}.DateInput_fang{bottom:100%;}.DateRangePickerInput{border-radius:", ";border-color:", ";overflow:hidden;& .DateInput{width:6rem;}& input.DateInput_input{color:", ";font-family:", ";font-size:1rem;font-weight:", ";box-sizing:border-box;height:38px;padding:12px 11px 8px;}.DateInput_fang{}}.DateRangePickerInput_clearDates{padding:", ";line-height:inherit;border-radius:10px;top:45%;transform:translateY(-45%);cursor:pointer;right:5px;height:calc(100% - 10px);display:flex;align-items:center;margin:0;}"], _BaseTheme.default.radius.regular, _BaseTheme.default.colors.bluegray, _BaseTheme.default.colors.gray, _BaseTheme.default.type.family.system, _BaseTheme.default.type.weight.regular, _ref => {
  let {
    size
  } = _ref;
  return size === _DatePicker.DatePickerSize.sm ? '0px 8px' : '3px 8px';
});

const PresetsWrapper = _styledComponents.default.div.withConfig({
  displayName: "DateRangePicker__PresetsWrapper",
  componentId: "design-system__sc-1vfgtnt-1"
})(["padding:0 22px 11px 22px;"]);

const resolvePresets = presets => {
  if (!presets) return undefined;
  const builder = predefinedPresetsBuilder();
  return presets.map(p => {
    switch (p) {
      case PredefinedPresets.Today:
        return builder[PredefinedPresets.Today]();

      case PredefinedPresets.Yesterday:
        return builder[PredefinedPresets.Yesterday]();

      case PredefinedPresets.Last7Days:
        return builder[PredefinedPresets.Last7Days]();

      case PredefinedPresets.MonthToDate:
        return builder[PredefinedPresets.MonthToDate]();

      case PredefinedPresets.Last30Days:
        return builder[PredefinedPresets.Last30Days]();

      case PredefinedPresets.PreviousMonth:
        return builder[PredefinedPresets.PreviousMonth]();

      default:
        return p;
    }
  });
};

const renderPresets = (resolvedPresets, startDate, endDate, onDatesChange) => /*#__PURE__*/_react.default.createElement(PresetsWrapper, null, /*#__PURE__*/_react.default.createElement(_LinkList.default, null, resolvedPresets.map(_ref2 => {
  let {
    text,
    start,
    end
  } = _ref2;

  const onSelectPreset = e => {
    e.preventDefault();
    onDatesChange({
      startDate: start,
      endDate: end
    });
  };

  return /*#__PURE__*/_react.default.createElement(_LinkListItem.default, {
    key: text,
    onClick: onSelectPreset
  }, text);
})));

const DateRangePicker = _ref3 => {
  let {
    startDate,
    endDate,
    startDateId,
    endDateId,
    onDatesChange,
    startDatePlaceholderText,
    endDatePlaceholderText,
    openDirection,
    anchorDirection,
    minDate,
    maxDate,
    isOutsideRange,
    displayFormat,
    showClearDates,
    onClose,
    size,
    withPortal,
    datePresets,
    calendarInfoPosition,
    appendToBody
  } = _ref3;
  const [focusedInput, setFocusedInput] = (0, _react.useState)(null);
  const {
    small,
    regular
  } = (0, _DatePicker.getSizeProps)(size);

  const onFocusChange = focused => setFocusedInput(focused);

  const internalOnClose = dates => {
    if (onClose) {
      onClose(dates);
    }
  };

  const resolvedPresets = (0, _react.useMemo)(() => resolvePresets(datePresets));
  const renderCalendarInfo = (0, _react.useCallback)(() => renderPresets(resolvedPresets, startDate, endDate, onDatesChange), [resolvedPresets, startDate, endDate, onDatesChange]);
  return /*#__PURE__*/_react.default.createElement(StyledWrapper, {
    size: size
  }, /*#__PURE__*/_react.default.createElement(_reactDates.DateRangePicker, {
    startDate: startDate ? (0, _moment.default)(startDate) : startDate,
    startDateId: startDateId,
    endDate: endDate ? (0, _moment.default)(endDate) : endDate,
    endDateId: endDateId,
    onDatesChange: onDatesChange,
    focusedInput: focusedInput,
    onFocusChange: onFocusChange,
    startDatePlaceholderText: startDatePlaceholderText,
    endDatePlaceholderText: endDatePlaceholderText,
    openDirection: openDirection,
    anchorDirection: anchorDirection,
    minDate: minDate ? (0, _moment.default)(minDate) : minDate,
    maxDate: maxDate ? (0, _moment.default)(maxDate) : maxDate,
    onClose: internalOnClose,
    showClearDates: showClearDates,
    isOutsideRange: isOutsideRange,
    displayFormat: displayFormat,
    small: small,
    regular: regular,
    withPortal: withPortal,
    calendarInfoPosition: calendarInfoPosition,
    appendToBody: appendToBody,
    renderCalendarInfo: datePresets ? renderCalendarInfo : undefined
  }));
};

DateRangePicker.propTypes = {
  startDate: _propTypes.default.oneOfType([_reactMomentProptypes.default.momentObj, _propTypes.default.string]).isRequired,
  endDate: _propTypes.default.oneOfType([_reactMomentProptypes.default.momentObj, _propTypes.default.string]).isRequired,
  startDateId: _propTypes.default.string.isRequired,
  endDateId: _propTypes.default.string.isRequired,
  onDatesChange: _propTypes.default.func.isRequired,
  startDatePlaceholderText: _propTypes.default.string,
  endDatePlaceholderText: _propTypes.default.string,
  showClearDates: _propTypes.default.bool,
  onClose: _propTypes.default.func,
  displayFormat: _propTypes.default.string,
  openDirection: _propTypes.default.oneOf([_DatePicker.DatePickerOpenDirection.up, _DatePicker.DatePickerOpenDirection.down]),
  anchorDirection: _propTypes.default.oneOf([_DatePicker.anchorOpenDirection.left, _DatePicker.anchorOpenDirection.right]),
  isOutsideRange: _propTypes.default.func,
  minDate: _propTypes.default.oneOfType([_reactMomentProptypes.default.momentObj, _propTypes.default.string]),
  maxDate: _propTypes.default.oneOfType([_reactMomentProptypes.default.momentObj, _propTypes.default.string]),
  size: _propTypes.default.oneOf([_DatePicker.DatePickerSize.sm, _DatePicker.DatePickerSize.md]),
  withPortal: _propTypes.default.bool,
  datePresets: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.oneOf([PredefinedPresets.Today, PredefinedPresets.Yesterday, PredefinedPresets.Last7Days, PredefinedPresets.MonthToDate, PredefinedPresets.Last30Days, PredefinedPresets.PreviousMonth]), _propTypes.default.shape({
    text: _propTypes.default.string,
    start: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string, _reactMomentProptypes.default.momentObj]),
    end: _propTypes.default.oneOfType([_propTypes.default.instanceOf(Date), _propTypes.default.string, _reactMomentProptypes.default.momentObj])
  })])),
  appendToBody: _propTypes.default.bool,
  calendarInfoPosition: _propTypes.default.string
};
DateRangePicker.defaultProps = {
  // eslint-disable-next-line no-unused-vars
  isOutsideRange: date => false,
  openDirection: null,
  anchorDirection: 'left',
  displayFormat: 'yyyy-MM-DD',
  onClose: null,
  showClearDates: false,
  startDatePlaceholderText: undefined,
  endDatePlaceholderText: undefined,
  minDate: undefined,
  maxDate: undefined,
  size: _DatePicker.DatePickerSize.md,
  withPortal: false,
  datePresets: undefined,
  calendarInfoPosition: 'before',
  appendToBody: false
};
var _default = DateRangePicker;
exports.default = _default;